import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PopularCourseCart.css'
import { Zoom } from 'react-reveal';


const PopularCourseCart = ({ course }) => {
    const { courseThubnail, title, _id } = course;

    //naviagate 
    const naviagate = useNavigate();

    const handleDetailsPopularCourse = () => {
        naviagate(`/popularCourseDetails/${_id}`);
    }


    return (
        <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
            <Zoom>
                <div className="shadow-lg text-center popularcart" style={{ minHeight: '250px', cursor: 'pointer' }} onClick={handleDetailsPopularCourse}>
                    <img src={courseThubnail} alt={title} className='img-fluid mb-3 w-100' />
                    <h5 className='mb-2 fw-bold fs-5'>{title}</h5>
                </div>
            </Zoom>
        </div>
    );
};

export default PopularCourseCart;